import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import EventsLanding from "../views/EventsLanding";
import MedicalGasSystemsService from "../views/MedicalGasSystemsService";
import OxygenGenerator from "../views/OxygenGenerator";
import RadiologyEquipments from "../views/RadiologyEquipments";
import GasManifold from "../views/GasManifold";
import HeadUnit from "../views/HeadUnit";
import GasOutlet from "../views/GasOutlet";
import GasAlarm from "../views/GasAlarm";
import VacuumSystem from "../views/VacuumSystem";
import OxygenTherapy from "../views/OxygenTherapy";
import ModularOperatingTheatre from "../views/ModularOperatingTheatre";
import GasSummit from "../views/GasSummit";

export default function Events(props) {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	async function init() {
		//run initializations here
	}

	function getView() {
		if(
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <EventsLanding/>
		} else if(
			appContext.navSubItem === 'gas_summit' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <GasSummit/>
		} 

		return null;
	}

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		const _view = getView();
		if(_view) {
			setView(_view);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return view;
}